import { Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useLoad } from "@/lib/hooks";
import { api, errMsg } from "@/lib/api";

export function SendDocButton({ kind, id, label = "Send to customer" }) {
  const [s, reload] = useLoad(`/tenant/documents/${kind}/${id}/send-status`);
  const send = async () => {
    try {
      const r = await api.post(`/tenant/documents/${kind}/${id}/send`);
      if (r.data.status === "skipped") toast.warning(`Not sent: ${String(r.data.reason || "").replace(/_/g, " ")}`);
      else toast.success(`Sending to ${r.data.to}. Delivery status appears in the notification log.`);
    } catch (e) { toast.error(errMsg(e)); }
    reload();
  };
  if (!s) return null;
  const btn = <Button variant="outline" data-testid={`${kind}-send-button`} disabled={!s.can_send} onClick={send}><Send className="mr-1 h-4 w-4" />{label}</Button>;
  if (s.can_send) return <span title={`Email to ${s.to}`}>{btn}</span>;
  return (
    <TooltipProvider delayDuration={0}><Tooltip><TooltipTrigger asChild><span tabIndex={0} className="inline-block cursor-not-allowed" data-testid={`${kind}-send-wrapper`}>{btn}</span></TooltipTrigger>
      <TooltipContent data-testid={`${kind}-send-tooltip`} className="max-w-xs">{s.reason}</TooltipContent></Tooltip></TooltipProvider>
  );
}
